import React from 'react';
import ReactDOM from 'react-dom';
import styles from './LoadingPopup.module.css';
import LoadingIcon from '../LoadingIcon/LoadingIcon';

interface LoadingPopupProps {
  isVisible: boolean;
  message?: string;
}

const LoadingPopup = ({ 
  isVisible, 
  message = 'Loading...' 
}: LoadingPopupProps) => {
  if (!isVisible) return null;

  const popupElement = document.getElementById("popup");
  
  if (!popupElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <LoadingIcon />
          <p className={styles.message}>{message}</p>
        </div>
      </div>
    </div>,
    popupElement
  );
};

export default LoadingPopup;
